import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {listingPagesEdit_template} from "../components/templates/listingPagesEdit_template";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";
import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import EmbedHelper from "../utils/EmbedHelper";
import {HubPageConfig, HubPagePinnedHubPage, HubPagePinnedHubPageSection} from "../utils/types/listing_page";
import { object } from "@amcharts/amcharts4/core";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let imageDescriptionEditor;
let imageCaptionEditor;
let galleryDescriptionEditor;
let bulkImageDescriptionEditor;
let bulkImageCaptionEditor;
let tagPickerSpecAreaEditor;
let blurbTextAreaEditor;

export class listing_page_edit extends vnModule_knockoutJS {

    public XHRHdl: XMLHttpRequestHandler;
    public XHRGetUserHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    protected listingPageEditTemplate: listingPagesEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;
    protected saveAndStay = false;

    protected imageXHRHdl: XMLHttpRequestHandler;
    protected galleryXHRHdl: XMLHttpRequestHandler;
    protected contentImageXHRHdl: XMLHttpRequestHandler;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
    protected imageMode : string;
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    protected isSaveGallery: any;
    public imagePickerHelper: imagePickerHelper;
    public embedHelper: EmbedHelper;

    private pollXhr: XMLHttpRequestHandler;
    private pollSearchDebounceTimer: ReturnType<typeof setTimeout> | null = null;
    private pollSearchRequestId = 0;

    constructor(vnAppZone) {
        super(vnAppZone);
        this.embedHelper = new EmbedHelper(this);

    }

    public getIdBrand(){
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected getModuleName() {
        return "listing_page_edit";
    }

    public getImagePickerHelper() {
        if (this.imagePickerHelper) {
            return this.imagePickerHelper;
        }

        return this.listingPageEditTemplate ? this.listingPageEditTemplate.imagePickerHelper : null;
    }

    public setImagePickerHelper(helper: imagePickerHelper): void {

        this.imagePickerHelper = helper;
    }

    buildContent() : Array<Element>{

        // create validation errors list template

        // create the transactions form
        this.listingPageEditTemplate = new listingPagesEdit_template("listingPageEditTemplate", this.viewModel, this);

        this.setupCKEditorBlurbEditTextArea();
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Hub Page Form");

        return [this.listingPageEditTemplate.build()];
    }

    fillPage() : void{

        this.setUpCkEditorTagsPickerEditTextArea();
        this.getReferences();

        // this.imagePickerHelper = new imagePickerHelper(
        //     this.listingPageEditTemplate.imagePicker,
        //     this.viewModel,
        //     this.getVnAppZone(),
        //     this
        // );
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    protected saveEditListingPage(){

        this.save();
    }


    // obtain the dynamic data required to fill the form
    protected  getReferences(): void {

        if( "getReferences" in this.XHRHdls ){
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.listingPageEditTemplate.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/references';


        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(this.listingPageEditTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferenceReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetReferenceReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let idBrand = obj.getVnAppZone().app.params.idBrand;
                let response = JSON.parse(req.request.response);
                obj.listingPageEditTemplate.setCategories(response.categories);
                obj.listingPageEditTemplate.setContentTypes(response.contentTypes);
                obj.listingPageEditTemplate.videoPickerHelper.setContentTypeFilter(response.contentTypes);
                obj.listingPageEditTemplate.videoPickerHelper.setCategoryFilter(response.categories);
                obj.listingPageEditTemplate.setSegments(response.segments);
                obj.listingPageEditTemplate.setTypes(response.types);
                obj.listingPageEditTemplate.setArticleTypes(response.articleTypes);
                obj.listingPageEditTemplate.setArticleTemplateLayouts(response.articleTemplateLayouts);
                obj.listingPageEditTemplate.setIdBrand(idBrand);
                obj.listingPageEditTemplate.disableArticleTypeOption(16, ["26", "44", "52"].indexOf(idBrand) === -1);
                obj.listingPageEditTemplate.setTagTypes(response.tagTypes);
                // obj.listingPageEditTemplate.setPinnedTagCards(response.pinnedTagCards);
                obj.listingPageEditTemplate.setPinnedListingPages(response.listingPages);
                obj.listingPageEditTemplate.setLayoutOptions(response.layouts);
                obj.listingPageEditTemplate.setPermissions(response.permissions);
                obj.listingPageEditTemplate.tagPicker.setTagViewBadgeOptions(response.badges);
                obj.listingPageEditTemplate.setArticleCharacteristics(response.articleCharacteristics);
                obj.listingPageEditTemplate.setAiSettings(response.aiSettings || {});
                obj.listingPageEditTemplate.titleColorSelector.setOptions(response.titleColors);

                if(response.tagHubTagTypeRestrictions){

                    obj.listingPageEditTemplate.setTagHubTagTypeRestrictions(response.tagHubTagTypeRestrictions);
                    if(response.tagHubTagTypeRestrictions.length > 0){

                        obj.listingPageEditTemplate.setIsTagHubEnabled(true);
                    }
                }

                obj.getFormData();
            });
        }
    }
    //
    // obtain the dynamic data required to fill the form
    protected getFormData(){

        if( "getFormData" in this.XHRHdls ){
            this.XHRHdl.cancelAndReset();
        }

        let id: number;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["listingPageEditTemplate"].id(id);
        }

        let usrReq_url: string;
        usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/get/' + id;

        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    protected onGetFormDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.listingPage != null) {

                    obj.listingPageEditTemplate.setListingPage(response.listingPage, response.pinnedTags);
                    obj.listingPageEditTemplate.setIdBrand(obj.getVnAppZone().app.params.idBrand);
                    obj.listingPageEditTemplate.setPermalinkBehavior(response.listingPage.isResolvable, response.permalinkListingPage ? response.permalinkListingPage : null);
                    obj.listingPageEditTemplate.setPinnedArticlesEnabled(response.listingPage.isPinnedArticlesEnabled) ;
                    obj.listingPageEditTemplate.setListingPageInterlinkEnabled(response.listingPage.listingPageInterlinkEnabled);
                    obj.listingPageEditTemplate.setRandomizePinnedArticles(response.listingPage.randomizePinnedArticles);
                    obj.listingPageEditTemplate.setInclusionRulesFields(response.listingPage.inclusionRules);
                    obj.listingPageEditTemplate.subContentArticles.setArticles(response.listingPage.contentTabs);
                    if(response.listingPage.featuredImage){
                        obj.listingPageEditTemplate.setImage(response.listingPage.featuredImage, "featured_image");
                        obj.listingPageEditTemplate.getTemplateViewModel().featuredImage(response.listingPage.featuredImage);
                    }
                    if(response.listingPage.hubPageIcon){
                        obj.listingPageEditTemplate.setImage(response.listingPage.hubPageIcon, "hubpage_icon");
                        obj.listingPageEditTemplate.getTemplateViewModel().featuredImage(response.listingPage.featuredImage);
                    }
                    if(response.listingPage.cardBackgroundImage){
                        obj.listingPageEditTemplate.setImage(response.listingPage.cardBackgroundImage, "card_background_image");
                    }
                    if(response.listingPage.thumbnailImage){
                        obj.listingPageEditTemplate.setImage(response.listingPage.thumbnailImage, "thumbnail_image");
                        obj.listingPageEditTemplate.getTemplateViewModel().thumbnailImage(response.listingPage.thumbnailImage);
                    }
                    if(response.listingPage.pinnedArticles != null) {

                        let pinnedArticles = obj.removeExpiredArticles(response.listingPage.pinnedArticles);
                        pinnedArticles = obj.updateTimeLeft(pinnedArticles);
                        obj.listingPageEditTemplate.setPinnedArticles(pinnedArticles);
                    }
                    if(response.listingPage.layout != null) {
                        obj.listingPageEditTemplate.setIdLayout(response.listingPage.layout.id);
                    }

                    obj.listingPageEditTemplate.setIsNotDeletable(response.listingPage.isNotDeletable);
                }

                    obj.listingPageEditTemplate.setPinnedTags(response.pinnedTags);
                    if (response.moreThemeWeeksTags) {
                        obj.listingPageEditTemplate.setMoreThemeWeeksTags(response.moreThemeWeeksTags);
                    }
                    let listingPageConfig = (response.listingPage != null) ? response.listingPage.config : null;
                obj.setPinnedListingPagesPositions(response.listingPages, listingPageConfig);
                obj.listingPageEditTemplate.setTagTypeFields(response.inclusionRuleFields);
                obj.listingPageEditTemplate.setIdBrand(obj.getVnAppZone().app.params.idBrand);


                obj.listingPageEditTemplate.setDisplayField(response.listingPage);
                obj.listingPageEditTemplate.updatePinnedArticleMaximumNumber();
                obj.listingPageEditTemplate.getTemplateViewModel().segmentsEnabled(response.segmentsEnabled == undefined ? false : response.segmentsEnabled);
                obj.listingPageEditTemplate.filterLayoutOptions();

                if(response.newsletterPromotion){
                    obj.listingPageEditTemplate.setNewsletterPromotion(response.newsletterPromotion);
                } else {
                    obj.listingPageEditTemplate.getTemplateViewModel().isListingPageNewsletterPromotionFetched = false;
                }
                obj.listingPageEditTemplate.setIsSidebarHidden(response.listingPage && response.listingPage.isSidebarHidden ? response.listingPage.isSidebarHidden : false);
                obj.listingPageEditTemplate.setIsListingHidden(response.listingPage && response.listingPage.isListingHidden ? response.listingPage.isListingHidden : false);
                obj.listingPageEditTemplate.setUsePinnedTagAsDataOnly(response.listingPage && response.listingPage.usePinnedTagAsDataOnly ? response.listingPage.usePinnedTagAsDataOnly : false);
                obj.loadingOut(obj.listingPageEditTemplate.builtTemplate);
            });
        }
    }
    //
    // remove articles added at an earlier date/time than the 'hours pinned' value selected
    private removeExpiredArticles(pinnedArticles)
    {
        let listOfArticles = []
        pinnedArticles.forEach( (article) =>
        {
            article.alternateTitle = (article.alternateTitle ? article.alternateTitle : '') // set alternate title
            let isoDateTimeString = article.expiry;
            if (article.timeLeft !== '') {
                let expireDateTime: number = new Date(isoDateTimeString).valueOf();
                // @TODO: date in mysql should be stored in UTC time
                let currentDateTimeString: string = new Date().toLocaleString("en-US", {timeZone: "America/Toronto"});
                let currentDateTime: number = new Date(currentDateTimeString).valueOf();
                let expireDateString: String = new Date(isoDateTimeString).toTimeString();
                let currentDateString: String = new Date().toTimeString();
                if(currentDateTime < expireDateTime)
                {
                    listOfArticles.push(article);
                }
            } else {
                listOfArticles.push(article);
            }

        });
        return listOfArticles;
    }
    //
    // Update the timeLeft value to the current number of hours left based on the expiry value
    private updateTimeLeft(pinnedArticles)
    {
        let listOfArticles = []
        pinnedArticles.forEach( (article) =>
        {
            let isoDateTimeString: string = article.expiry;
            if (article.timeLeft !== '') {
                let expireDateTime: Number = new Date(isoDateTimeString).valueOf();
                // @TODO: date in mysql should be stored in UTC time
                let currentDateTimeString: string = new Date().toLocaleString("en-US", {timeZone: "America/Toronto"});
                let currentDateTime: Number = new Date(currentDateTimeString).valueOf();

                if(currentDateTime < expireDateTime)
                {
                    let secondsDiff = Math.abs(expireDateTime.valueOf() - currentDateTime.valueOf()) / 1000;

                    let hoursDiff = Math.floor(secondsDiff / 3600);
                    secondsDiff -= hoursDiff * 3600; // subtract hours total from current diff

                    let minutesDiff = Math.floor(secondsDiff / 60) % 60;
                    let minutesDiffString: string = minutesDiff.toString();
                    if (minutesDiff < 10 ) {
                        minutesDiffString = '0' + minutesDiffString;
                    }
                    secondsDiff -= minutesDiff * 60; // subtract minutes total from current diff

                    secondsDiff = secondsDiff % 60;
                    let secondsDiffString: string = secondsDiff.toString();
                    if (secondsDiff < 10 ) {
                        secondsDiffString = '0' + secondsDiffString;
                    }
                    hoursDiff = Math.floor(hoursDiff); // round up to the highest integer

                    //article.timeLeft = hoursDiff + ':' + minutesDiffString + ':' + secondsDiffString; // replace the line below with this line to show seconds
                    article.timeLeft = hoursDiff + ':' + minutesDiffString + ':00';

                    listOfArticles.push(article);
                }
            } else {
                listOfArticles.push(article);
            }

        });
        return listOfArticles;
    }

    protected save(option = null){

        if( "save" in this.XHRHdls ){
            this.XHRHdl.cancelAndReset();
        }

        this.saveAndStay = (option === 'stay');

        this.loadingIn(this.listingPageEditTemplate.builtTemplate);
        // build the right url for the API call
        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand  + '/config/listing-pages/save/';

        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(this.listingPageEditTemplate.getViewModelForRequest())] );

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPostListingPageReturn;
        this.XHRHdl.execute();
    }

    protected onPostListingPageReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                let url: string = '/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/listing-pages';

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Listing Page saved successfully!");
                obj.listingPageEditTemplate.clearMessages();

                if (response.id) {
                    obj.listingPageEditTemplate.getTemplateViewModel().id(response.id);
                }

                obj.saveArticleAiNewsletterPromotion(false, () => {
                    if (!obj.saveAndStay) {
                        page.redirect(url);
                    } else {
                        // New hub: update URL so refresh stays on the edit page
                        if (response.id && !obj.getVnAppZone().app.params.id) {
                            const editUrl = '/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/listing-pages/edit/' + response.id;
                            window.history.pushState({}, '', editUrl);
                            obj.getVnAppZone().app.params.id = response.id;
                        }
                        obj.getVnAppZone().showNotificationToModule();
                    }
                    obj.saveAndStay = false;
                });
            });
            obj.loadingOut(obj.listingPageEditTemplate.builtTemplate);
        }
    }


    protected viewArticle(id){
        let url = '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/view/' + id;
        window.open(url, '_blank');
    }


    protected onAutocompleteOptionChange(idElement) {

        if (idElement === "filterAutocompleteTagEditAffiliate_template") {

            this.listingPageEditTemplate.tagPicker.updateTagEditAutomaticPricingOptions();
        }

        else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
            this.listingPageEditTemplate.tagPicker.updateTagViewAutomaticPricingOptions();
        }

        if (idElement == "tagTypeFilter" || idElement == 'filterTagType') {

            this.listingPageEditTemplate.tagTypeFilter.getTemplateViewModel().options([]);
            let filterTagTypes = this.listingPageEditTemplate.tagTypeFilter.getTemplateViewModel();
            let tagType = filterTagTypes.optionObj();

            if (!tagType) {
                this.listingPageEditTemplate.tagTypeFilter.clearSelectedOption();
            } else {
                this.listingPageEditTemplate.setSelectedTagType(tagType)
            }

            if (idElement == "filterTagType") {

                this.listingPageEditTemplate.tagPicker.onAddTagTypeFilter();
            }

        }else if (idElement === "tagPickerSourceFilterTagType") {

            this.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.addTagTypeRestriction();
        } else if ( idElement == "filterEditTagType" ){

            this.listingPageEditTemplate.tagPicker.onEditTagTypeFilter();
        } else if (idElement == "vignetteFilter") {
            this.clearValidationErrors();
            this.listingPageEditTemplate.tagPicker.tagEdit.setSelectedVignette(this.listingPageEditTemplate.tagPicker.tagEdit.vignetteFilter.getOptionObj());
        } else if (idElement == "defaultVignetteFilter") {
            this.clearValidationErrors();
            this.listingPageEditTemplate.tagPicker.tagEdit.setSelectedDefaultVignette(this.listingPageEditTemplate.tagPicker.tagEdit.defaultVignetteFilter.getOptionObj());
        }

    }

    public filterDropdownOnChange(idElement){

        switch (idElement) {
            case 'titleColorSelector':
                // Title color dropdown does not drive any other form section.
                // Prevent the default behavior from refreshing image picker data.
                break;
            case 'level1Filter':
                this.listingPageEditTemplate.setLevel2Filters();
                break;
            case 'inclusionRuleTagTypeFieldsFilter':
                this.listingPageEditTemplate.handleInclusionRules(idElement);
                break;
            case 'typeSelector':
                this.listingPageEditTemplate.setSelectedTypeIsTrending();
                break;
            case 'videoOrientationFilter':
            case 'videoRatioFilter':
                this.listingPageEditTemplate.videoPickerHelper.resetPagination();
                this.listingPageEditTemplate.videoPickerHelper.getVideosData();
                break;
            case 'articleTypeSelector':
                this.listingPageEditTemplate.filterLayoutOptions();
                break;
            case 'articleTemplateLayoutSelector':
                break;
            default:
                this.getImageData();
                break;
        }

    }

    public getSuggestions(keyword, idElement) {

        if(idElement == 'filterTagType' || idElement == 'tagTypeFilter' || idElement == 'tagPickerSourceFilterTagType'){
            this.getTagTypesSuggestion(keyword,idElement)
        } else if(idElement == "filterAddNewTagType" || idElement == 'filterEditTagType'){
            this.getTagTypesSuggestion(keyword,idElement, true);
        } else if(idElement == 'articleFilter'){
            this.getArticlesSuggestion(keyword,idElement)
        } else if (idElement == "filterAutocompleteTagViewAffiliate_template" || idElement == "filterAutocompleteTagEditAffiliate_template") {

            this.getAffiliatesSuggestion(keyword, 5);
        } else if (idElement == "filterAutocompleteLocales_template") {
                this.getLocaleSuggestion(keyword);
        } else if (idElement == 'tagSourcePickerTagFilter'){

            this.getTagPickerSpecificationTagSuggestions(keyword);
        } else if (idElement == "vignetteFilter") {
            this.getVignettesSuggestion(keyword, this.onGetVignettesSuggestionReturn);
        } else if (idElement == "defaultVignetteFilter") {
            this.getVignettesSuggestion(keyword, this.onGetDefaultVignettesSuggestionReturn);
        } else if (idElement == "channelFilter") {

            this.getChannelsSuggestion(keyword);
        }
    }

    public getVignettesSuggestion(keyword, onReadyStateFunction) {
        const idBrand = this.getVnAppZone().app.params.idBrand;

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}};
        let usrReq_url: string = `/api/brand/${idBrand}/search/tags/vignettes/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetVignettesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetVignettesSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data) {
                    let vignettes = response.data;
                    vignettes.forEach(vignette => {
                        vignette.name += ` (${vignette.id})`;
                    });
                    obj.listingPageEditTemplate.tagPicker.tagEdit.vignetteFilter.setOptions(vignettes);
                }
            });
        }
    }

    protected onGetDefaultVignettesSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data) {
                    let vignettes = response.data;
                    vignettes.forEach(vignette => {
                        vignette.name += ` (${vignette.id})`;
                    });
                    obj.listingPageEditTemplate.tagPicker.tagEdit.defaultVignetteFilter.setOptions(vignettes);
                }
            });
        }
    }

    private getTagPickerSpecificationTagSuggestions(keyword) {

        let tagTypeFieldParams = this.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.getViewModelForRequest();
        let typeRestrictions = tagTypeFieldParams.typeRestrictions;
        this.getTagsByTypes(keyword, typeRestrictions);
    }

    protected getTagsByTypes(keyword, typeRestrictions = []) {

        this.XHRHdl.cancelAndReset();

        let usrReq_url: string = '/api/tags/get_by_types/';
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            usrReq_url = '/api/brand/' + idBrand + '/tags/get_by_types/';
        }
        let subViewModel = {
            keyword: keyword,
            tagTypesIds: typeRestrictions,
        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagByTypesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagByTypesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                let tags = responseParsed.data;
                if(tags){

                    if (obj.XHRHdlCaller == "getSuggestions_tagSourcePickerTagFilter" || obj.XHRHdlCaller == "tag_picker_edit") {

                        obj.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.setTags(tags);
                    }
                }
            });
        }
    }

    protected getAffiliatesSuggestion(keyword, limit) {


        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, limit: limit}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/affiliate/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
        this.XHRHdl.execute();
    }
    protected onGetAffiliatesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let affiateSuggestions = [];

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.affiliates && Array.isArray(responseParsed.affiliates) && responseParsed.affiliates.length > 0) {
                    affiateSuggestions = responseParsed.affiliates;
                }

                obj.listingPageEditTemplate.tagPicker.setTagViewAffiliateFilterOptions(affiateSuggestions);
                obj.listingPageEditTemplate.tagPicker.setTagEditAffiliateFilterOptions(affiateSuggestions);
            });
        }
    }

    public getLocaleSuggestion(keyword) {
        const locales = this.listingPageEditTemplate.tagPicker.getTagEditLocales();

        if (typeof locales != "undefined") {
          let matches = locales.filter((l) => (
            l.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
            l.countryCode.toLowerCase() === keyword.toLowerCase()
          ));

          this.listingPageEditTemplate.tagPicker.setTagEditLocaleFilterOptions(matches);
          return matches;
        }

        return null;
      }

    protected getArticlesSuggestion(keyword, idElement) {

        this.XHRHdlCaller = "onAutocompleteFilterArticle_" + idElement;

        if( "getArticlesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }

        let subViewModel: any = {list: {keyword: keyword}, idElement: idElement, isSubContent: false};

        if(idElement == "subContentArticlesFilter"){
            subViewModel.isSubContent = true;
        }

        if(this.listingPageEditTemplate.getTemplateViewModel().listingPageConfigType() === 'homepage_video' && idElement === 'articleFilter') {
            subViewModel.idTemplate = 15;
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let response = JSON.parse(req.request.response);

                if (response.data.articles) {
                    let articles = [];

                    for(let article of response.data.articles){

                        article.name = article.title;

                        articles.push(article);

                    }

                    if (obj.XHRHdlCaller == "onAutocompleteFilterArticle_subContentArticlesFilter") {

                        obj.listingPageEditTemplate.setSubContentArticlesFilterAutocomplete(articles);
                    }else{
                        obj.listingPageEditTemplate.setArticleFilterAutocomplete(articles);
                    }


                }

            });
        }
    }

    protected getTagTypeFields(tagTypeId, idElement) {

        if( "getTagTypeFields" in this.XHRHdls ){
            this.XHRHdls["getTagTypeFields"].cancelAndReset();
        }

        let subViewModel = {dataTypes: ['tag','tags'], idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/fields/get_by_tag_type/" + tagTypeId + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagTypeFields"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getTagTypeFields"].onReadyStateFunction = this.onGetTagTypeFieldsReturn;
        this.XHRHdls["getTagTypeFields"].execute();
    }

    protected onGetTagTypeFieldsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let response = JSON.parse(req.request.response);

                if (response.data) {

                    obj.listingPageEditTemplate.setTagTypeFields(response.data);
                }

            });
        }
    }

    public getTagsSuggestion(keyword, idElement) {

        if (idElement == "tagSourcePickerTagFilter") { // @TODO: all elements should do this like in articles_edit_new.ts
            this.getSuggestions(keyword,idElement);
        } else {
            if( "getTagsSuggestion" in this.XHRHdls ){
                this.XHRHdls["getTagsSuggestion"].cancelAndReset();
            }
            const idBrand = this.getVnAppZone().app.params.idBrand;

            let usrReq_url: string = `/api/brand/${idBrand}/search/tag/`;
            let usrReq_params: Array<Array<string>> = [];
            let subViewModel:any;

            if (idElement == 'inclusionRuleTagFilter') {
                let fieldId = this.listingPageEditTemplate.getInclusionRuleFieldOptionId();
                usrReq_url = `/api/brand/${idBrand}/tags/get_tag_values/${fieldId}/`;
            } else if (idElement == 'tagHubTagFilter') {
                usrReq_url = `/api/brand/${idBrand}/tags/get_by_types`;
                subViewModel = {
                    idBrand,
                    pagination: { itemPerPage:25 },
                    keyword,
                    tagTypesIds: this.listingPageEditTemplate.getTagHubTagTypeRestrictions(),
                    idElement,
                    isSelectable: true
                };
            } else if (idElement == 'themePageTagFilter') {
                // Match payload shape used by articles/add tag picker suggestions
                // so the backend returns the expected tag list.
                subViewModel = {
                    filter: {
                        keyword: keyword,
                        limit: 5,
                        idTagType: null,
                        getActive: [1],
                        getSelectable: [0, 1],
                        getNonSelectable: false,
                        imageAndSpecSelectable: false,
                        specFields: false
                    }
                };
            }
            if (!subViewModel) {
                subViewModel = {
                    pagination: { itemPerPage:25 },
                    filter: { keyword: keyword },
                    idElement: idElement
                };
            }
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            if (idElement == 'themePageTagFilter') {
                // We removed `idElement` from payload, so route UI update via closure.
                this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = (req, obj) => {
                    return function () {
                        obj.manageResponse(req, obj, function () {
                            let response = JSON.parse(req.request.response);
                            if (response.data.tags) {
                                obj.listingPageEditTemplate.setTagFilter(response.data.tags, 'themePageTagFilter');
                            }
                        });
                    };
                };
            } else {
                this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
            }
            this.XHRHdls["getTagsSuggestion"].execute();
        }
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let requestParameters = JSON.parse(req.parameters[0][1]);
                let idElement = requestParameters.idElement;

                let response = JSON.parse(req.request.response);

                if (response.data.tags) {
                    if (idElement == "tagSourcePickerTagFilter") {
                        obj.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.setTags(response.data.tags);
                    } else {
                        obj.listingPageEditTemplate.setTagFilter(response.data.tags, idElement);
                    }
                } else if (idElement == 'tagHubTagFilter') {
                    obj.listingPageEditTemplate.setTagFilter(response.data, idElement);
                }

            });
        }
    }

    protected delete(){

        if( "delete" in this.XHRHdls ){
            this.XHRHdls["delete"].cancelAndReset();
        }

        this.loadingIn(this.listingPageEditTemplate.builtTemplate);

        let formReq_url: string;
        formReq_url = '/api/' + this.getVnAppZone().app.params.idBrand  + '/config/listing-pages/delete';


        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(this.listingPageEditTemplate.getViewModelForRequest())] );

        this.XHRHdls["delete"] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        this.XHRHdls["delete"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["delete"].onReadyStateFunction = this.onPostListingPageReturn;
        this.XHRHdls["delete"].execute();
    }

    protected onDeleteListingPageReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
                obj.listingPageEditTemplate.clearMessages();

                let url: string = '/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/listing-pages';
                page.redirect(url);
            });
            obj.loadingOut(obj.listingPageEditTemplate.builtTemplate);
        }
    }

    public filterSimpleOnChange(idElement): void {

        switch (idElement) {
            case 'tagFilter':
                this.listingPageEditTemplate.addPinnedTag();
                break;
            case 'moreThemeWeeksTagFilter':
                this.listingPageEditTemplate.addMoreThemeWeeksTag();
                break;
            case "filterTagSearch":
                this.listingPageEditTemplate.tagPicker.resetPagination();
                this.getTagData();
                break;
            case 'tagTypeFilter':
                this.listingPageEditTemplate.addTagType();
                this.getTagData();
                break;
            case 'tagHubTagFilter':
                this.validateTagHubTagSelection();
                break;
            case 'themePageTagFilter':
                break;
            case 'inclusionRuleTagFilter':
            case 'inclusionRuleTagTypeFieldsFilter':
                this.listingPageEditTemplate.handleInclusionRules(idElement);
                break;
            case "tagSourcePickerTagFilter":
                this.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.addSelectedTag();
                break;
            case "videoKeywordFilter":
                this.getVideoPickerHelper().resetPagination();
                this.getVideoPickerHelper().getVideosData();
                break;
            case "pinnedListingPages_filterListingPage":
            case 'secondaryPinnedListingPages_secondaryFilterListingPage':
                break;
            default:
                this.getImageData();
                this.getGalleryData();
                break;
        }
    }

    protected getImage(imgSrc){

        if (this.contentImageXHRHdl) {
            this.contentImageXHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().app.params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + '/images/get-content-image/';
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["imgSrc", imgSrc]);

        this.contentImageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
        this.contentImageXHRHdl.execute();
    }

    protected onImageRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                let image = responseParsed.image.data[0];

                obj.listingPageEditTemplate.imagePicker.editImage(image, obj.getImageMode());

                obj.listingPageEditTemplate.imagePicker.hideLoading();
            });
        }
    }

    public cancelForm() {
        this.cancel();
    }

    public cancel(): void {

        let url: string = '/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages';

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Listing Page Action Canceled!");
        this.listingPageEditTemplate.clearMessages();

        page.redirect(url);
    }

    public getListingPagesSuggestion(keyword, idElement): void {

        if( "getListingPagesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getListingPagesSuggestion"].cancelAndReset();
        }


        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/search/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getListingPagesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getListingPagesSuggestion"].onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdls["getListingPagesSuggestion"].execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    obj.listingPageEditTemplate.setFilterListingPagesAutoComplete(response.data.listingPages, response.data.idElement);
                }

            });
        }
    }

    public validateTagHubTagSelection() {
        if( "validateTagHubTag" in this.XHRHdls ){
            this.XHRHdls["validateTagHubTag"].cancelAndReset();
        }

        const tag = this.listingPageEditTemplate.tagHubTagFilter.getTagObj();
        this.listingPageEditTemplate.setTagHubTagErrors([]);
        if (!tag) {
            return;
        }

        let subViewModel = {idTag: `${tag.id}`};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/tag-hub/tag/validate/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["validateTagHubTag"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["validateTagHubTag"].mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdls["validateTagHubTag"].onReadyStateFunction = this.onValidateTagHubTagSelection;
        this.XHRHdls["validateTagHubTag"].execute();
    }

    public onValidateTagHubTagSelection(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response && !response.isValid && response.errors) {
                    console.log(response.errors);
                    obj.listingPageEditTemplate.setTagHubTagErrors(response.errors);
                }

            });
        };
    }

    public triggerWarningNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public clearValidationErrors(){

        this.validationTemplate.clearMessages();
        this.listingPageEditTemplate.removeValidationClass();
    }

    public getTagTypesSuggestion(keyword, idElement, restrictOwnedTagTypes = false) {

        if( "getTagTypesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagTypesSuggestion"].cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage:25},filter: {keyword: keyword, restrictOwnedTagTypes : restrictOwnedTagTypes},  idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/type/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagTypesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getTagTypesSuggestion"].onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdls["getTagTypesSuggestion"].execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let response = JSON.parse(req.request.response);

                if (response.data.tagTypes) {

                    response.data.tagTypes.forEach((tagType) => {
                        tagType.name += ` ${tagType.formattedDataset}`;
                    })

                    if(response.data.idElement == 'filterTagType'){
                        obj.listingPageEditTemplate.tagPicker.setTagTypeOptions(response.data.tagTypes);
                    } else if(response.data.idElement == 'filterEditTagType') { //@TODO revisit semantics..
                        obj.listingPageEditTemplate.tagPicker.setEditTagTypeOptions(response.data.tagTypes);
                    } else if(response.data.idElement == 'tagTypeFilter') { //@TODO revisit semantics..
                        obj.listingPageEditTemplate.setTagTypes(response.data.tagTypes);
                    } else if (response.data.idElement == 'tagPickerSourceFilterTagType') {
                        obj.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.tagPickerSourceFilterTagType.setOptions(response.data.tagTypes);
                    } else if (response.data.idElement == 'filterAddNewTagType') {
                        //const idBrand = obj.getVnAppZone().app.params.idBrand;
                        // filter out owned tag types that aren't owned by this brand.
                        //response.data.tagTypes = response.data.tagTypes.filter((tagType: emaki_tag_type) => tagType.brandOwner? tagType.brandOwner.id == idBrand : true);

                        obj.listingPageEditTemplate.tagPicker.setAddNewTagTypeOptions(response.data.tagTypes);
                    }
                }

            });
        }
    }

    public getPinnedTagCardsSuggestion(keyword, idElement) {

        if( "getPinnedTagCardsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getPinnedTagCardsSuggestion"].cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage:25},filter: {keyword: keyword},  idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getPinnedTagCardsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getPinnedTagCardsSuggestion"].onReadyStateFunction = this.onGetPinnedTagCardsSuggestionReturn;
        this.XHRHdls["getPinnedTagCardsSuggestion"].execute();
    }

    protected onGetPinnedTagCardsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let response = JSON.parse(req.request.response);

                if (response.data.tags) {

                    obj.listingPageEditTemplate.setPinnedTagCards(response.data.tags);
                }

            });
        }
    }

    protected onAutocompleteInputClear(idElement) {

        if (idElement == "tagTypeFilter") {
            this.listingPageEditTemplate.getTemplateViewModel().tagType(null)
            this.listingPageEditTemplate.getTemplateViewModel().level1Filter.setOptions([])
            this.listingPageEditTemplate.getTemplateViewModel().level2Filter.setOptions([])
        } else if (idElement == "vignetteFilter") {
            this.listingPageEditTemplate.tagPicker.tagEdit.setSelectedVignette(null);
        } else if (idElement == "defaultVignetteFilter") {
            this.listingPageEditTemplate.tagPicker.tagEdit.setSelectedDefaultVignette(null);
        }
    }

    protected onAutocompleteInputClick(idElement) {

    if (idElement == "tagTypeFilter") {

        let filterTypes = this.listingPageEditTemplate.tagTypeFilter.getTemplateViewModel();

        if (filterTypes.addNewSelected()) {
            this.listingPageEditTemplate.tagTypeFilter.setOptions([]);

        }
    }
}

    protected generateEmbed(source){

        this.loadingIn(this.listingPageEditTemplate.builtTemplate);

        this.embedHelper.generateEmbed(
            source,
            this.listingPageEditTemplate.getTemplateViewModel().embedder.embedType(),
        );
    }

    protected abortEmbedGeneration(){
        this.embedHelper.abortEmbedGeneration();
    }

    public onGenerateEmbedRequestReturn(req, obj){

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.listingPageEditTemplate.embedder.setEmbedData(responseParsed.data);
                    obj.listingPageEditTemplate.embedder.previewEmbedType('embed_'+ responseParsed.data.name);
                }else{
                    obj.listingPageEditTemplate.getTemplateViewModel().embedder.embedErrors(responseParsed);
                }
            }

            obj.loadingOut(obj.listingPageEditTemplate.builtTemplate);
        }
    }

    protected addEmbedCodeToPage(value){

        const embed = document.createElement('div');

        embed.innerHTML = value;

        const embedderPreview = document.getElementById('embedder-preview');

        embedderPreview.innerHTML = "";

        embedderPreview.appendChild(embed);
        this.listingPageEditTemplate.getTemplateViewModel().setEmbedHTML(value);

        this.listingPageEditTemplate.getTemplateViewModel().onClickCloseEmbeds(false);
        this.listingPageEditTemplate.getTemplateViewModel().embedder.resetEmbedPopUp();
    }


    private setPinnedListingPagesPositions(pinnedListingPages, listingPageConfig) {

        let primaryListingPages = (pinnedListingPages || []).filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.PRIMARY);
        this.setPrimaryPinnedListingPages(primaryListingPages);

        if (listingPageConfig && this.listingPageEditTemplate.isHomePageHubPage(listingPageConfig)) {
            let secondaryListingPages = (pinnedListingPages || []).filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.SECONDARY);
            this.setSecondaryPinnedListingPages(secondaryListingPages, primaryListingPages.length);
        }
    }

    private setPrimaryPinnedListingPages(primaryListingPages) {
        for (let i = 0; i < primaryListingPages.length; i++) {

            if (primaryListingPages[i].position == '') {
                primaryListingPages[i].position = i + 1;
            }
        }
        this.listingPageEditTemplate.setPinnedListingPages(primaryListingPages);
    }

    private setSecondaryPinnedListingPages(secondaryListingPages, primaryListingPagesCount) {
        for (let i = 0; i < secondaryListingPages.length; i++) {

            if (secondaryListingPages[i].position == '') {
                secondaryListingPages[i].position = i + 1;
            }
        }

        this.listingPageEditTemplate.setSecondaryPinnedListingPages(secondaryListingPages, primaryListingPagesCount);
    }

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected showTagPicker(editor) {

        this.listingPageEditTemplate.tagPicker.resetPagination();
        this.getTagData();
    }

    protected getTagData() {

        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }

        this.listingPageEditTemplate.tagPicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/tags/get/';
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.listingPageEditTemplate.tagPicker.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.tagSearchXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    protected onGetTagDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateTagPickerForm(responseParsed);
                obj.listingPageEditTemplate.tagPicker.hideLoading();
            })
        }
    }

    protected updateTagPickerForm(responseParsed) {
        let selectedTags = this.listingPageEditTemplate.tagPicker.getSelectedTags();

        if( responseParsed.data ){
            for(let tag of responseParsed.data){
                tag.selected = false;
                let tagSelected = selectedTags.find(i => i.id == tag.id);
                if (tagSelected) {
                    tag.selected = true;
                }
            }
            this.listingPageEditTemplate.tagPicker.setTagsPagination(responseParsed.totalPage, responseParsed.currentPage);
            this.listingPageEditTemplate.tagPicker.setTagResults(responseParsed.data);
        }

    }

    public getTag(tag, select = false){
        this.getTags([tag], select);
    }

    protected getTags(idTags, select = false) {

        if (this.tagXHRHdl) {
            this.tagXHRHdl.cancelAndReset();
        }

        if (idTags.length > 1) {

            this.XHRHdlCaller = "tag_picker_group";
            this.listingPageEditTemplate.tagPicker.showLoading();
        } else {

            if (select) {

                this.XHRHdlCaller = "tag_picker_select";
                this.listingPageEditTemplate.tagPicker.showLoading();
            } else {

                this.XHRHdlCaller = "tag_picker_view";
                this.listingPageEditTemplate.tagPicker.showViewLoading();
            }

        }


        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTags: idTags})]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.tagXHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.tags && responseParsed.tags.length > 0) {

                    if(obj.XHRHdlCaller == "tag_picker_group"){
                        let tagsResponse = responseParsed.tags;
                        let tags = [];
                        for(let response of tagsResponse){
                            let tag = response.tag;
                            tag.specsValues = response.specsValues;
                            tag.specDefaults = response.specDefaults;
                            tag.communityRating = response.communityRating? response.communityRating : { average: null, count: 0 };
                            tag.includeCommunityRating = response.includeCommunityRating? response.includeCommunityRating : false;
                            tags.push(tag);
                        }
                        obj.listingPageEditTemplate.tagPicker.selectTags(tags);
                    }else{
                        let tag = responseParsed.tags[0].tag;
                        tag.specsValues =  responseParsed.tags[0].specsValues;
                        tag.specDefaults =  responseParsed.tags[0].specDefaults;
                        tag.communityRating = responseParsed.tags[0].communityRating? responseParsed.tags[0].communityRating : { average: null, count: 0 };
                        tag.includeCommunityRating = responseParsed.tags[0].includeCommunityRating? responseParsed.tags[0].includeCommunityRating : false;
                        if(obj.XHRHdlCaller == "tag_picker_select"){
                            obj.listingPageEditTemplate.tagPicker.selectTag({... tag, pros : [], cons : [] }, true);
                        }else if(obj.XHRHdlCaller == "tag_picker_view"){
                            obj.listingPageEditTemplate.tagPicker.setTag({... tag, pros : [], cons : [] });
                            //obj.listingPageEditTemplate.tagPicker.selectTag({... tag, pros : [], cons : [] }, true);
                        }
                    }
                }
            });

            obj.listingPageEditTemplate.tagPicker.hideViewLoading();
            obj.listingPageEditTemplate.tagPicker.hideLoading();
            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.listingPageEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.listingPageEditTemplate.removeTagPickerValidationClass();
            }
        }
    }

    public getTagToEdit() {
        return this.listingPageEditTemplate.tagPicker.tagView.getTagToEdit()
    }

    protected getTagTypes(listTagTypesId) {

        if(listTagTypesId && listTagTypesId.length>0){

            this.XHRHdl.cancelAndReset();

            let usrReq_url: string = '/api/tag/types/get/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON({filters      : {
                    ids : listTagTypesId
                }})]);
            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetTagTypesReturn;
            this.XHRHdl.execute();
        }
    }

    protected onGetTagTypesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data) {
                    obj.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.setTagTypesRestriction(response.data)
                }

            });
        }
    }

    // protected editImage(image, mode = ""){
    //     this.listingPageEditTemplate.imagePicker.editImage(image, mode);
    // }

    // protected showImagePicker(image, mode = ""){
    //     this.listingPageEditTemplate.showImagePicker(image, mode);
    // }

    protected getGalleryData() {

        if( this.galleryXHRHdl ){
            this.galleryXHRHdl.cancelAndReset();
        }
        this.listingPageEditTemplate.imagePicker.showLoading();


        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/'+idBrand+'/galleries/get/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(this.listingPageEditTemplate.imagePicker.getViewModelForRequest())]);

        this.galleryXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.galleryXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;

        this.galleryXHRHdl.onReadyStateFunction = this.onGetGalleryDataReturn;
        this.galleryXHRHdl.execute();
    }

    protected onGetGalleryDataReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                if(obj.listingPageEditTemplate.imagePicker.getSelectedTab() == 'galleries' || obj.isSaveGallery) {
                    obj.listingPageEditTemplate.imagePicker.hideLoading();
                    obj.isSaveGallery = false;
                }
            })
        }
    }

    public setImageDescription(description) {

        imageDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public setImageCaption(caption) {

        imageCaptionEditor.setData(caption, function () {
            this.resetUndo();
        });
    }

    public setGalleryDescription(description) {

        galleryDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public getImageDescription(description) {

        return imageDescriptionEditor.getData();
    }

    public getGalleryDescription(description) {

        return galleryDescriptionEditor.getData();
    }

    public getImageCaption(description) {

        return imageCaptionEditor.getData();
    }

    public setRichTextTagSpecAreaEditor(value){

        tagPickerSpecAreaEditor.setData(value);
    }

    public getRichTextTagSpecAreaEditor() {

        return tagPickerSpecAreaEditor.getData();
    }

    public setRichTextBlurbTextAreaEditor(value){
        if (blurbTextAreaEditor && blurbTextAreaEditor.setData) {
            blurbTextAreaEditor.setData(value || '');
        } else {
            this.setupCKEditorBlurbEditTextArea(() => {
                blurbTextAreaEditor.setData(value || '');
            });
        }
    }

    public getRichTextBlurbTextAreaEditor() {
        this.setupCKEditorBlurbEditTextArea();
        if (!blurbTextAreaEditor || !blurbTextAreaEditor.getData) return '';
        return blurbTextAreaEditor.getData();
    }

    protected updateImagePickerForm(responseParsed) {
        let selectedImages = this.listingPageEditTemplate.imagePicker.getSelectedImages();

        if( responseParsed.paginatedImages && responseParsed.paginatedImages.data ){
            for(let image of responseParsed.paginatedImages.data){
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.listingPageEditTemplate.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.listingPageEditTemplate.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }

        if (responseParsed.imagesInContent) {
            for (let image of responseParsed.imagesInContent) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.listingPageEditTemplate.imagePicker.setImagesInContent(responseParsed.imagesInContent);
        }

        let selectedGallery = this.listingPageEditTemplate.imagePicker.getSelectedGallery();

        if( responseParsed.paginatedGalleries && responseParsed.paginatedGalleries.data){
            for(let gallery of responseParsed.paginatedGalleries.data){
                gallery.selected = false;
                if (selectedGallery != null) {
                    if (selectedGallery.id == gallery.id) {
                        gallery.selected = true;
                    }
                }
            }
            this.listingPageEditTemplate.imagePicker.setGalleryPagination(responseParsed.paginatedGalleries);
            this.listingPageEditTemplate.imagePicker.setGalleryResults(responseParsed.paginatedGalleries.data);
        }

        if (responseParsed.ratios) {
            this.listingPageEditTemplate.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.listingPageEditTemplate.imagePicker.setOrientations(responseParsed.orientations);
        }

        if (responseParsed.uploadSources) {
            this.listingPageEditTemplate.imagePicker.setUploadSources(responseParsed.uploadSources, responseParsed.selectedUploadSource);
        }

        if (responseParsed.idBrand) {
            this.listingPageEditTemplate.imagePicker.setIdBrand(responseParsed.idBrand);
        }

    }

    protected bytesToSize(bytes) {
        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    };

    public setTagEditLock(tag){
        this.listingPageEditTemplate.tagPicker.showViewLoading();
        this.XHRHdlCaller = "tag_picker_edit";
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTags: [tag.id] , lockItem : true })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();
    }

    public releaseBrandTagLock(idTag){

        this.listingPageEditTemplate.tagPicker.showViewLoading();
        this.XHRHdlCaller = "tag_picker_edit_cancel";
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let usrReq_url = `/api/brand/${idBrand}/tags/release/${idTag}`;

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTag })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();

    }

    private sendSimpleRequest(req, obj)  {


        return () => {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                if(req.request.status == 200) {

                    obj.listingPageEditTemplate.handleTagInArticle(obj.XHRHdlCaller);

                } else if (req.request.status == 423) {

                    if (obj.XHRHdlCaller == "tag_picker_edit_cancel") {

                        obj.listingPageEditTemplate.handleTagInArticle(obj.XHRHdlCaller);
                    } else {

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        obj.getVnAppZone().showNotificationToModule();
                    }

                }

                obj.listingPageEditTemplate.tagPicker.hideViewLoading();
            }
        }
    }

    protected insertTagElement(elementToReplace, element, target, tagObject){

        let massagedElement;

        if (
            tagObject &&
            tagObject.id &&
            tagObject.name &&
            ((tagObject.image && tagObject.image.url) || (tagObject.imageOverride && tagObject.imageOverride.url)) &&
            element
        ) {
            massagedElement = {
                "id": tagObject.id.toString(),
                "type": "display_card",
                "title": tagObject.name,
                "source": element
            };

            if (tagObject.viewType !== "hide") {

                if (tagObject.image && tagObject.image.url) {
                    massagedElement.tagImage = { "src": tagObject.image.url };
                }

                if (tagObject.imageOverride && tagObject.imageOverride.url) {
                    massagedElement.imageOverride = { "src": tagObject.imageOverride.url };
                }
            }

        } else {
            massagedElement = null;
        }

        switch (target) {
            case 'primaryDeals':
                this.listingPageEditTemplate.addPrimaryDeal(massagedElement, tagObject);
                break;
            case 'secondaryDeals':
                this.listingPageEditTemplate.addSecondaryDeal(massagedElement, tagObject);
                break;
            default:
                this.listingPageEditTemplate.setPinnedTag(massagedElement);
                break;
        }
    }

    protected saveTag(saveData) {

        this.listingPageEditTemplate.tagPicker.showEditLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/save/";

        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(saveData)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveTagReturn
        XHRHdl.execute();
    }


    protected onSaveTagReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let showPickerIfTagNew = false;
                if(responseParsed.tag){

                    obj.listingPageEditTemplate.tagPicker.hideEdit();

                    const {tempTagItemPros, tempTagItemCons} = obj.listingPageEditTemplate.tagPicker.tagEdit.getTemplateViewModel()

                    let tag = responseParsed.tag;

                    tag.specsValues = responseParsed.specsValues;
                    tag.specDefaults = responseParsed.specDefaults;
                    tag.includeCommunityRating = responseParsed.includeCommunityRating;
                    tag.communityRating = responseParsed.communityRating;
                    tag.hasTagHubPage = responseParsed.hasTagHubPage;

                    if(responseParsed.newTag){
                        showPickerIfTagNew = true;
                        obj.listingPageEditTemplate.tagPicker.setTagAfterAddNew(tag);
                    }else{
                        obj.listingPageEditTemplate.tagPicker.setTagAfterSave({...tag, pros : tempTagItemPros(), cons : tempTagItemCons() });
                    }

                    obj.releaseBrandTagLock(tag.id);
                    obj.listingPageEditTemplate.tagPicker.updateSelectedTagAfterSave(tag);

                    if (showPickerIfTagNew) {
                        obj.listingPageEditTemplate.tagPicker.setTagAfterSave({...tag, pros : tempTagItemPros(), cons : tempTagItemCons() });
                    }
                }
            });

            obj.listingPageEditTemplate.tagPicker.hideEditLoading();

            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.listingPageEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.listingPageEditTemplate.removeTagPickerValidationClass();
            }
        }
    }

    protected getImageData(keyword = null) {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.listingPageEditTemplate.imagePicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/get/';
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.listingPageEditTemplate.imagePicker.getViewModelForRequest();
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.listingPageEditTemplate.imagePicker.hideLoading();
                if(obj.listingPageEditTemplate.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
            })
        }
    }

    protected insertImage(image, target, extra_option) {
        if (target.element){

            let element = target.element;
            element.parentElement.removeChild(element);
            target = target.editor;
        }

        if (target == "tagImageOverride" || target == "tagImageOverrideEdit" ) {
            this.listingPageEditTemplate.tagPicker.setTagImageOverride(image);
        }else if (target == "tagImageEdit") {
            this.listingPageEditTemplate.tagPicker.setTagImage(image);
        }else if (target == "tagIconImageEdit") {
            this.listingPageEditTemplate.tagPicker.setTagIconImage(image); // @TODO maybe don't do this
        }else if (target == "tagImageBadge") {
            this.listingPageEditTemplate.tagPicker.setTagImageBadge(image);
        }else if (target == "featured_image" || target == 'hubpage_icon' || target == 'deals_caroussel_image' || target == 'theme_page_background_image' || target == 'card_background_image' || target == 'thumbnail_image'){
            this.listingPageEditTemplate.setImage(image, target);
        }

    }

    protected saveImages(images, insert, param, insertType='image') {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/save/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(images)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let response = JSON.parse(req.request.response);

                    let target = obj.listingPageEditTemplate.getImagePickerTarget();

                    if( target == "featured_image"){
                        obj.listingPageEditTemplate.imageWidgetForFeaturedImage.setImage(response.images[0].image)
                    }

                    if( target == "hubpage_icon"){
                        obj.listingPageEditTemplate.imageWidgetForHubpageIcon.setImage(response.images[0].image)
                    }

                    if( target == "theme_page_background_image"){
                        obj.listingPageEditTemplate.imageWidgetForThemePageBackground.setImage(response.images[0].image)
                    }

                    if( target == "card_background_image"){
                        obj.listingPageEditTemplate.imageWidgetForCardBackground.setImage(response.images[0].image)
                    }

                    if( target == "alternate_image"){
                        obj.listingPageEditTemplate.imageWidgetForAlternateImage.setImage(response.images[0].image)
                    }

                    if(target === 'thumbnail_image'){
                        obj.listingPageEditTemplate.imageWidgetForThumbnailImage.setImage(response.images[0].image)
                    }

                    obj.listingPageEditTemplate.setImagePickerTarget(null);

                    obj.listingPageEditTemplate.imagePicker.onImageSaveReturn(response.images, insert, param, insertType);

                    obj.getImageData();
                })

            }
        });
        XHRHdl.execute();
    }

    protected saveGallery(gallery, insert, param) {

        this.isSaveGallery = true;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/'+idBrand+'/galleries/save/';
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(gallery)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.listingPageEditTemplate.imagePicker.onGallerySaveReturn(responseParsed.gallery, insert, param);
                    obj.getGalleryData();
                })

            }
        });
        XHRHdl.execute();
    }

    protected deleteImage(image) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/delete/' + image.id;
        let formReq_params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.listingPageEditTemplate.imagePicker.showLoading()
        XHRHdl.onReadyStateFunction = ((req, obj) => () => {

            if (req.request.status == 400){
                obj.listingPageEditTemplate.imagePicker.hideLoading()
                obj.listingPageEditTemplate.imagePicker.hide()
            }

            obj.manageResponse(req, obj, function () {
                obj.getImageData();
            })

        });
        XHRHdl.execute();
    }

    protected handleFiles(files) {

        this.uploadImages(files);

    }

    protected initializeProgress(numFiles) {
        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
        this.uploadProgress = [];

        for (let i = numFiles; i > 0; i--) {
            this.uploadProgress.push(0)
        }
    }

    protected resetProgress() {
        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
    }

    protected updateProgress(fileNumber, percent): void {

        this.progressBar.value = percent;
    }

    protected uploadImages(files) {


        console.log('trial  - ' + this.uploadStatus.currentTrial);

        let parent = this;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/upload/';

        var formData = new FormData();

        this.initializeProgress(files.length);

        if (files.length > 1) {

            this.listingPageEditTemplate.imagePicker.showLoading();
        }

        this.listingPageEditTemplate.imagePicker.clearFilters();

        // upload status vars.
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {

            formData.append("file_" + i, files[i]);

        }
        formData.append("idBrand", idBrand);

        let request = [];
        var xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        let onReadyStateFunction = (function (req, obj) {

            return function () {

                if (req.request.readyState == 4) {

                    if (req.request.status == 200) {

                        // reset the upload status when successful operation is complete.
                        obj.uploadStatus.reset();
                        let fileElement: any = document.getElementById("fileElem");
                        fileElement.value = '';
                        let response = JSON.parse(req.request.response);

                        obj.updateProgress(response.images.length, 100) // <- Add this

                        if (response.images.length == 1 && response.errors.length == 0) {

                            obj.listingPageEditTemplate.imagePicker.editImage(response.images[0]);
                            obj.listingPageEditTemplate.imagePicker.hideLoading();
                        }

                        if ((response.images.length == 1 && response.errors.length == 1) || response.images.length > 1) {

                            obj.listingPageEditTemplate.imagePicker.hideImageAdd();
                            obj.listingPageEditTemplate.imagePicker.handleBulkImages(response.images);
                            obj.listingPageEditTemplate.imagePicker.hideLoading();

                            if (response.errors.length == 1) {
                                obj.listingPageEditTemplate.imagePicker.imagesBulkEdit.validationsList.setMessages(response.errors);
                            }
                        }

                        obj.resetProgress();
                        obj.validationTemplate.clearMessages();

                    } else if (req.request.status == 400) {

                        let responseParsed = JSON.parse(req.request.response)
                        obj.listingPageEditTemplate.imagePicker.imageAdd.validationsList.setMessages(responseParsed.validations);
                        obj.listingPageEditTemplate.imagePicker.hideLoading();
                        window.scrollTo(0, 0);

                    } else {
                        obj.uploadStatus.isInProgress = false;
                        obj.listingPageEditTemplate.imagePicker.showUploadError();
                    }
                }

            }
        });

        // call on request changes state
        xhttp.onreadystatechange = onReadyStateFunction(request, this);

        let firstTime = new Date().getTime();
        xhttp.upload.addEventListener("progress", function (e) {

            parent.uploadStatus.progress = e.loaded;
            let progressTime = new Date().getTime();
            let diff =  progressTime - firstTime;
            firstTime = progressTime;
            console.log('Upload Image progress: ', e.loaded, e.total, parent.uploadStatus.progress, diff);
        });

        xhttp.upload.addEventListener('loadend', (e) => {

            if (!parent.uploadStatus.isInProgress && parent.uploadStatus.trialsReached()) {
                xhttp.abort();
                parent.listingPageEditTemplate.imagePicker.showPickerUploadError();
                parent.listingPageEditTemplate.imagePicker.hideLoading();
            }
            console.log('Upload Image Loadend: ', parent.uploadStatus.progress, e.loaded, e.total);
        });

        xhttp.upload.addEventListener('loadstart', (e) => {

            console.log('timeout started');
            setTimeout(() => {

                // check after one second if the progress is blocked then trigger another try.
                if (!parent.uploadStatus.isInProgress && !parent.uploadStatus.trialsReached()) {
                    xhttp.abort();
                    parent.uploadImages(files);
                }
            }, 1000);

        });

        // Send request with data
        xhttp.send(formData);
    }

    public reset(){
        this.uploadStatus.reset();
        this.listingPageEditTemplate.imagePicker.hidePickerUploadError();
    }

    private getImageMode() : string{
        return this.imageMode
    }

    private setImageMode(mode : string) : void {
        this.imageMode = mode
    }

    public resetEditedSpec() {
        this.listingPageEditTemplate.tagPicker.tagEdit.resetEditedSpec();
    }

    protected validateTagSpecFromSource(idField, idType, label, dataType, restrictionsArray, value = null, idBrand = null) {

        let formReq_url: string = '/api/tags/field/validate/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {idType: idType, label: label, idField: idField, dataType: dataType,typeRestrictions: restrictionsArray, value: value, idBrand: idBrand};
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.onValidateSpecification;
        XHRHdl.execute();
    }

    public onValidateSpecification(req, obj){

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.valid) {
                    obj.listingPageEditTemplate.tagPicker.tagEdit.appendSpecification()
                } else {
                    let messages = responseParsed.validations.map((v) => { return { field: v.dataField, label: v.label, messages: v.messages };});
                    obj.listingPageEditTemplate.tagPicker.tagEdit.tagTypeFieldEdit.validationsList.setMessages(messages);
                    window.scrollTo(0, 0);
                }
            }
        }
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected initializeCkEditors() {

        for (let name in CKEDITOR.instances) {
            CKEDITOR.instances[name].destroy(true);
        }

        this.listingPageEditTemplate.initTagPickerCkEditors();
        // @TODO revisit this!
        this.initializeImagePickerCkEditors();
    }

    protected setupCKEditorBlurbEditTextArea(callback = (()=>{})) {
        if (blurbTextAreaEditor) return;
        const element =  document.querySelector('#blurbTextArea');
        if (element){
            classicEditor.create(
                element,
                {
                    toolbar: [ 'bold', '|', 'italic', 'link'],
                    link:{
                        addTargetToExternalLinks: true
                    }
                }).then( newEditor => {
                    blurbTextAreaEditor = newEditor;
                    callback();
                }).catch( error => {
                        console.error( error );
                });
        }
    }

    protected setUpCkEditorTagsPickerEditTextArea(){

        const element = document.querySelector( '#tagPickerTagTypeFieldTextArea' );
        if (element){
            classicEditor.create(
                element,
                {
                    toolbar: [ 'bold', '|', 'italic', 'link'],
                    link:{
                        addTargetToExternalLinks: true
                    }
                }).then( newEditor => {
                    tagPickerSpecAreaEditor = newEditor;
                }).catch( error => {
                        console.error( error );
                });
        }
    }

    protected initializeImagePickerCkEditors() {


        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
                {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}},

            ]);
        }

        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if(dialogName == "cellProperties"){
                // "bgColor"
                // "borderColor"
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        // Image Description Editor
        this.initCkEditor('image_description');
        imageDescriptionEditor = CKEDITOR.instances.image_description;

        // Image Caption Editor
        this.initCkEditor('image_caption');
        imageCaptionEditor = CKEDITOR.instances.image_caption;

        // Gallery Description
        this.initCkEditor('gallery_description');
        galleryDescriptionEditor = CKEDITOR.instances.gallery_description;

        this.initCkEditor('bulk_image_description');
        bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;

        this.initCkEditor('bulk_image_caption');
        bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;

    }

    protected initCkEditor(idElement) {

        let height, toolbarMA;
        let disallowedContent = 'p';
        //contextmenu,tabletools,tableselection
        let removePlugins = 'elementspath,liststyle,image,forms';
        if ( idElement == 'article_directory_item_description' || idElement == 'sandbox_directory_item_description')
        {
            disallowedContent += ',ul,ol,li';
            removePlugins+= ',list';
            toolbarMA = [[ 'Source','Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'ImgBtn', 'VideoBtn' , 'Bold', 'Italic', 'Strike', '-','LinkBtn', 'Maximize']];
            height = '500px';
        }
        else if ( idElement == "image_description" || idElement == "image_caption" || idElement == "gallery_description")
        {
            disallowedContent += ',ul,ol,li';
            removePlugins+= ',list';
            toolbarMA = [[ 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'Bold', 'Italic', 'Strike', '-','LinkBtn', 'Maximize']];
            height = '125px';
        }
        else if (idElement == "bulk_image_description" || idElement == "bulk_image_caption"){
            disallowedContent += ',ul,ol,li';
            removePlugins+= ',list';
            toolbarMA = [[ 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'Bold', 'Italic', 'Strike', '-','LinkBtn', 'Maximize']];
            height = '75px';
        }
        else
        {
            height = '500px';
            //height = '1500px';
            toolbarMA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'VideoBtn', 'TagBtn', 'EmbedBtn', 'UpdateBtn','KeyPointsBtn','Styles'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn', 'Maximize']];
        }

        CKEDITOR.replace(idElement, {
            height: height,
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'span(*)[!data-field];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*]',
            disallowedContent: disallowedContent,
            removePlugins: removePlugins,
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            },
            toolbar_MA : toolbarMA
        });
        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=7.5'];
        CKEDITOR.config.skin = "emakiCustomComprehensive";
        CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
        CKEDITOR.config.forcePasteAsPlainText = false;
        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
    }


    public filterMultipleSelectorOnChange(idElement = null) {

        if (idElement == 'categoryVideoFilter' || idElement == 'contentTypeVideoFilter') {
            this.listingPageEditTemplate.videoPickerHelper.resetPagination();
            this.listingPageEditTemplate.videoPickerHelper.getVideosData();
        } else {
            this.listingPageEditTemplate.updateSelectedCategories();
            this.listingPageEditTemplate.updateSelectedContentTypes();
            this.listingPageEditTemplate.updateSelectedSegments();
            this.listingPageEditTemplate.updateSelectedArticleCharacteristics();
        }
    }

    public setIsImageOptimized(val) {
        // TODO implement method when you delete an image through imagePickerHelper
    }

    public insertVideo(param, target, data) {
        if(target == "tagPickerEdit_tagVideo") {
            this.listingPageEditTemplate.tagPicker.tagEdit.setTagVideo(data);
        }
        this.listingPageEditTemplate.videoPickerHelper.hideVideoPicker();
    }

    public getVideoPickerHelper() {

        return this.listingPageEditTemplate.videoPickerHelper
    }

    public onGetVideosDataReturn(req, obj){
        return function (req, obj) {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                const {orientations, paginatedVideos, ratios} = responseParsed;

                obj.listingPageEditTemplate.videoPickerHelper.setVideoPagination(paginatedVideos);
                obj.listingPageEditTemplate.videoPickerHelper.setVideos(paginatedVideos.data);
                if (ratios) {
                    obj.listingPageEditTemplate.videoPickerHelper.setRatios(ratios);
                }

                if (orientations) {
                    obj.listingPageEditTemplate.videoPickerHelper.setOrientations(orientations);
                }
                obj.listingPageEditTemplate.videoPickerHelper.hideLoading();

            });
        }.bind(this, req, obj.callerModule);
    }

    public getChannelsSuggestion(keyword) {
        const idBrand = this.getVnAppZone().app.params.idBrand;

        this.XHRHdl.cancelAndReset();

        let subViewModel = {
            pagination: { itemPerPage: 25 },
            filter: { keyword: keyword , availableForUse: true},
        };

        let usrReq_url: string = `/api/brand/${idBrand}/channels/search/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetChannelsSuggestionReturn;
        this.XHRHdl.execute();
    }

    public onGetChannelsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listingPageEditTemplate.setChannelsSuggestions(response.data);

            });
        };
    }

    protected onPromptInputChangeClear(idElement) {

        this.clearValidationErrors();

        // if (idElement === "filterAutocompleteTagEditAffiliate_template") {
        //     this.articlesEdit.tagPicker.clearTagEditAutomaticPricingOptions();
        // } else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
        //     this.articlesEdit.tagPicker.clearTagViewAutomaticPricingOptions();
        // } else if (idElement == "channelAutocomplete_template") {
        //     this.articlesEdit.clearChannelSelections();
        // }
    }

    protected getUserById(id, idElement) {
        if (this.XHRGetUserHdl) {
          this.XHRGetUserHdl.cancelAndReset();
        }

        let subViewModel: any = {
          list: { idUser: id },
          idElement: idElement,
        };
        let usrReq_url: string = null;

        switch (idElement) {
          default:
            usrReq_url =
              "/api/brand/" +
              this.getVnAppZone().app.params.idBrand +
              "/search/user/";
            break;
        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRGetUserHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRGetUserHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRGetUserHdl.execute();
    }


    protected getUsersSuggestion(keyword, idElement) {
      if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
      }

      let subViewModel: any = {
        list: { keyword: keyword },
        idElement: idElement,
      };
      let usrReq_url: string = null;

      switch (idElement) {
        default:
          usrReq_url =
            "/api/brand/" +
            this.getVnAppZone().app.params.idBrand +
            "/search/user/";
          break;
      }

      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(subViewModel)]);
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

      this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
      this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);

          if (responseParsed.data.idElement == "filterUser_blurbAuthor") {
            obj.listingPageEditTemplate.setBlurbAuthor(responseParsed.data.users, responseParsed.data);
          }
        });
      };
    }

    public removeImage(target) {
        this.listingPageEditTemplate.removeImage(target);
    }

    public saveArticleAiNewsletterPromotion(regenerate = false, onComplete: Function = null) {

        this.loadingIn(document.getElementById("ai-newsletter-promotion-section"));
        const vm = this.listingPageEditTemplate.getTemplateViewModel();
        const idListingPage = vm.id();
        const idBrand = this.getIdBrand();

        if (!idListingPage || isNaN(idListingPage)) {
            console.warn("Cannot save newsletter promotion: idListingPage is missing.");
            this.loadingOut(document.getElementById("ai-newsletter-promotion-section"));
            this.getVnAppZone().notification = new vn_app_zone_notification(
                vn_app_zone_notification.TYPE_ERROR,
                "Listing Page must be saved first!");
            this.getVnAppZone().showNotificationToModule()
            if (onComplete) onComplete();
            return;
        }

        let viewModel = {
            title: vm.aiNewsletterPromotionTitle(),
            excerpt: vm.aiNewsletterPromotionExcerpt(),
            isEnabled: vm.isAiNewsletterPromotionEnabled(),
            regenerate: regenerate
        };

        // build the right url for the API call
        const url = `/api/brand/${idBrand}/listingPage/${idListingPage}/newsletterPromotion/save/`;
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveArticleAiNewsletterPromotion(onComplete);
        this.XHRHdl.execute();
    }

    public onSaveArticleAiNewsletterPromotion(onComplete: Function = null) {

        const obj = this;
        return function (req, context) {
            if (!context) {
                context = obj;
            }
            context.manageResponse(req, context, function () {
                let response = JSON.parse(req.request.response);
                const data = response.data || {};
                const vm = context.listingPageEditTemplate.getTemplateViewModel();
                vm.aiNewsletterPromotionTitle(data.title || '');
                vm.aiNewsletterPromotionExcerpt(data.excerpt || '');
            });
            context.loadingOut(document.getElementById("ai-newsletter-promotion-section"));
            if (onComplete) {
                onComplete();
            }
        }
    }

    public showTagPickerForDeals(mode, target) {
        this.getTagData();
        this.listingPageEditTemplate.showTagPicker(mode, target)
    }

    public onClickPinnedDealEdit(dealType, data) {
        this.listingPageEditTemplate.editPinnedTag(data, dealType);
    }

    public searchPoll(keyword: string) {
        const trimmed = String(keyword || "").trim();
        if (trimmed.length < 3) {
            this.listingPageEditTemplate.getTemplateViewModel().poll_options([]);
            this.listingPageEditTemplate.getTemplateViewModel().pollSearchEmpty(false);
            return;
        }

        if (this.pollSearchDebounceTimer) {
            clearTimeout(this.pollSearchDebounceTimer);
        }

        this.pollSearchDebounceTimer = setTimeout(() => {
            this.executePollSearch(trimmed);
        }, 300);
    }

    protected executePollSearch(keyword: string) {
        if (this.pollXhr) {
            this.pollXhr.cancelAndReset();
        }

        const requestId = ++this.pollSearchRequestId;
        const idBrand = this.getVnAppZone().app.params.idBrand;
        const url = `/api/brand/${idBrand}/polls/search/`;
        const params = [['keyword', keyword]];

        this.pollXhr = new XMLHttpRequestHandler(url, params, this);
        this.pollXhr.mode = XMLHttpRequestHandler_requestType.POST;
        this.pollXhr.onReadyStateFunction = (req, obj) => {
            return () => {
                if (req.request.readyState !== 4 || req.request.status === 0) {
                    return;
                }
                obj.manageResponse(req, obj, function () {
                    if (requestId !== obj.pollSearchRequestId) {
                        return;
                    }
                    if (req.request.status == 200) {
                        const response = JSON.parse(req.request.response);
                        obj.listingPageEditTemplate.getTemplateViewModel().poll_options(Array.isArray(response) ? response : []);
                        obj.listingPageEditTemplate.getTemplateViewModel().pollSearchEmpty(Array.isArray(response) ? response.length == 0 : true);
                    }
                });
            };
        };
        this.pollXhr.execute();
    }

    public loadPollById(idPoll: number) {
        if (!idPoll) {
            return;
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const url = `/api/brand/${idBrand}/polls/get/${idPoll}/`;
        const xhr = new XMLHttpRequestHandler(url, [], this);
        xhr.mode = XMLHttpRequestHandler_requestType.GET;
        xhr.onReadyStateFunction = (req, obj) => {
            return () => {
                obj.manageResponse(req, obj, function () {
                    if (req.request.readyState == 4 && req.request.status == 200) {
                        const response = JSON.parse(req.request.response);
                        const poll = response.data;
                        if (poll && poll.name) {
                            obj.listingPageEditTemplate.getTemplateViewModel().pollName(poll.name);
                        }
                    }
                });
            };
        };
        xhr.execute();
    }

    public preview(): void {
        this.loadingIn(this.listingPageEditTemplate.builtTemplate);

        const listingPageId = this.listingPageEditTemplate.getTemplateViewModel().id() || 0;
        const brandId = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = `/api/brand/${brandId}/config/listing-pages/preview/${listingPageId}/`;
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(this.listingPageEditTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPreviewReturn;
        this.XHRHdl.execute();
    }

    protected onPreviewReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.openPreview(responseParsed.data);
            });

            obj.loadingOut(obj.listingPageEditTemplate.builtTemplate);
        };
    }

    protected openPreview(data) {
        let origin = document.location.origin;
        let brandDomain = data.brand.domain;
        if (!origin.includes("https://emakicms.com")) {
            brandDomain = brandDomain.replace("www.", "");
        }

        let listingPageId = data.emakiPreview && data.emakiPreview.id ? data.emakiPreview.id : 0;
        let url = origin.replace("emakicms.com", brandDomain) + "/preview/listing-page/" + listingPageId + "/";

        if (url.includes("mig1")) {
            url = url.replace("mig1", "qa2");
        } else if (url.includes("mig2")) {
            url = url.replace("mig2", "qa8");
        } else if (url.includes("mig3")) {
            url = url.replace("mig3", "qa7");
        } else if (url.includes("mig4")) {
            url = url.replace("mig4", "qa1");
        }

        var f = document.createElement("form");
        f.action = url;
        f.method = "POST";
        f.target = "_blank";

        var tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "token";
        tokenInput.value = "PWjvmuQqaq`;33}4";
        f.appendChild(tokenInput);

        if (data.emakiPreview) {
            var listingPageInput = document.createElement("input");
            listingPageInput.type = "hidden";
            listingPageInput.name = "listingPage";
            listingPageInput.value = JSON.stringify(data.emakiPreview);
            f.appendChild(listingPageInput);
        }

        if (data.latestArticles) {
            var latestArticlesInput = document.createElement("input");
            latestArticlesInput.type = "hidden";
            latestArticlesInput.name = "latestArticles";
            latestArticlesInput.value = JSON.stringify(data.latestArticles);
            f.appendChild(latestArticlesInput);
        }

        document.body.appendChild(f);
        f.submit();
        document.body.removeChild(f);
    }
}



// WEBPACK FOOTER //
// ./js/modules/listing_page_edit.ts